import React from "react";
import { Col, Row } from "react-bootstrap";
import DataImportProgressModal from "./DataImportProgressModal";
import DataImportMinimisedModal from "./DataImportMinimised";
import CompleteMessage from "./CompleteMessage";

export default function Complete({ onComplete }) {
  return (
    <div>
      <Row className="mb-5 mt-3 m-5">
        <CompleteMessage />
      </Row>
      <Row className="mb-5 mt-3 m-5">
        <Col xs={12} lg={6} className="pe-5 border-end">
          <DataImportProgressModal />
          <DataImportMinimisedModal />
        </Col>
      </Row>
      <div className="d-flex justify-content-end">
        <button type="button" className="btn btn-colored px-3 rounded-pill" onClick={onComplete}>
          SAVE
        </button>
      </div>
    </div>
  );
}
